// assets
import { IconCalendarClock, IconChecklist } from '@tabler/icons-react'

// constant
const icons = { IconChecklist, IconCalendarClock }

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const task = {
  id: 'tasks',
  type: 'group',
  title: 'Tasks',
  needAdmin: true,
  children: [
    {
      id: 'tasks',
      title: 'Tasks',
      type: 'item',
      url: '/tasks',
      icon: icons.IconChecklist,
      breadcrumbs: false
    }
  ]
}

export default task
